// getKeyFromQueryParam :: String -> String
function getKeyFromQueryParam(param) {
  const index = param.indexOf('=');
  return index < 0 ? param : param.substr(0, index);
}

// getValueFromQueryParam :: String -> String
function getValueFromQueryParam(param) {
  const index = param.indexOf('=');
  return (index < 0 || index + 1 == param.length)
    ? null : param.substr(index + 1, param.length - index);
}

// findTextsContainsPattern :: Array<String>, RegExp -> Array<String>
export function findTextsContainsPattern(texts, pattern) {
  return texts.filter(href => pattern.test(href));
}

// interface BrowserInfo {
//     cookie: string;
//     language: string;
//     languages: string;
//     url: string;
//     userAgent: string;
// }
// getBrowserInfo -> BrowserInfo
export function getBrowserInfo() {
  return {
    cookie: document.cookie,
    language: window.navigator.language,
    languages: window.navigator.languages,
    url: window.location.href,
    userAgent: window.navigator.userAgent
  };
}

// generateGUID -> String
export function generateGUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0, v = (c == 'x') ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * @param {Document} document - The title of the book.
 * @param {string} tagName - The author of the book.
 *
 * @returns {NodeListOf<Element>}
 */
// getElementsByTagName :: String -> NodeListOf<Element>
export function getElementsByTagName(tagName) {
  return document.getElementsByTagName(tagName);
}

// getSearchFromHref :: String -> String
export function getSearchFromHref(href) {
  const index = href.indexOf('?');
  return index !== -1 ? href.substring(href.indexOf('?')) : '';
}

// documentIsVisible :: -> Bool
export function documentIsVisible() {
  return document.visibilityState && document.visibilityState === 'visible';
}

// retrieveParamsFromSearch :: String -> Object
export function retrieveParamsFromSearch(search) {
  const params = {}, pairs = search.substr(1).replace(/\+/g, ' ').split('&');

  pairs.forEach(function (pair) {
    const k = decodeURIComponent(getKeyFromQueryParam(pair));
    if (!k) return;

    let v = getValueFromQueryParam(pair);
    if (v) v = decodeURIComponent(v);

    if (!(k in params)) {
      params[k] = v;
    } else if (params[k] instanceof Array) {
      params[k].push(v);
    } else {
      params[k] = [params[k], v];
    }
  });

  return params;
}

export function unflatten(data) {
  var result = {};
  for (var i in data) {
    var keys = i.split('.');
    keys.reduce(function (acc, current, j) {
      return acc[current] || (acc[current] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 == j ? data[i] : {}) : [])
    }, result)
  }
  return result
}


// todo better name?
export function getResourceUrl(widgetLocation, url) {
  const widgetHref = widgetLocation.href;
  return widgetHref.slice(0, widgetHref.indexOf('/#')) + '/' + url;
}

/**
 * if referrer exists - check if it is different then hostname and if it is return it,
 * otherwise return widgetReferrer
 *
 * @param {string} hostname - only domain without port number
 * @param {string} referrer - document.referrer
 * @param {string} widgetReferrer - referrer stored in widget
 *
 * @returns {string} new referrer or empty string
 */
export function getReferrer(hostname, referrer, widgetReferrer) {
  return !referrer ? referrer :
    (new RegExp(hostname)).test(referrer) ? (widgetReferrer || referrer) :
      referrer;
}

export function polyfill() {
  if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict';
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }
}

/**
 * @param {Object} obj - object with any key case
 *
 * @returns {Object} - object with keys converted to lowercase
 */
export function keysToLowerCase(obj) {
  var lowerCaseObject = {};

  Object.keys(obj).forEach(function (ele) {
    return lowerCaseObject[ele.toLowerCase()] = obj[ele];
  });

  return lowerCaseObject;
}
